import { render, staticRenderFns } from "./edit-homefire-policy-form.vue?vue&type=template&id=022d5c0c&scoped=true&"
import script from "./edit-homefire-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-homefire-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d5c0c",
  null
  
)

export default component.exports